import compact from "lodash-es/compact";

import { ButtonGroup } from "../Button";
import { FeedbackGraphic } from "../Feedback/FeedbackGraphic";
import { SG } from "../SpacingGroup/SpacingGroup";
import { Heading, Paragraph } from "../TypographicElements/TypographicElements";

import type { FeedbackGraphicType } from "../Feedback/FeedbackGraphic";
import type { JSX, ReactNode } from "react";

import * as styles from "./emptyState.scss";

interface EmptyStateProps {
	/**
	 * An optional graphic to show at the top of the empty state.
	 */
	graphic?: FeedbackGraphicType;
	/**
	 * An optional title to show above {@link description}.
	 */
	title?: string;
	/**
	 * The description text to show in the middle of the empty state.
	 *
	 * This is meant to be mainly plain text, text link may be used if the link fits better in context instead of being placed as a separate action,
	 * otherwise prefer {@link link} when possible.
	 */
	description: ReactNode;
	/**
	 * Optional CTA buttons to show below {@link description}, there should be at max 2 buttons.
	 * @example
	 * [
	 *   <Button key="1" onClick={noop} appearance="primary">Primary</Button>,
	 *   <Button key="2" onClick={noop} appearance="secondary">Secondary</Button>
	 * ]
	 */
	buttons?: (JSX.Element | Falsy)[];
	/**
	 * An optional link to show below {@link buttons}, used for such as "read more" or some other non-CTA actions.
	 */
	link?: JSX.Element;
	testId?: string;

	/**
	 * @deprecated To be cleaned up along with EmptyState component
	 */
	dontUse_FeedbackGraphic_targetWidth?: number;
}

export const EmptyState = ({
	graphic,
	title,
	description,
	buttons,
	link,
	testId,
	dontUse_FeedbackGraphic_targetWidth,
}: EmptyStateProps) => {
	return (
		<div className={styles.centerer} data-testid={testId}>
			<div className={styles.wrapper}>
				<SG section gap="16">
					{graphic && <FeedbackGraphic type={graphic} dontUse_targetWidth={dontUse_FeedbackGraphic_targetWidth} />}
					<SG gap="8" align="center">
						{title && <Heading textCenter>{title}</Heading>}
						<Paragraph textCenter>{description}</Paragraph>
					</SG>
					<SG gap="16" align="center">
						<ButtonGroup direction="column">{compact(buttons)}</ButtonGroup>
						{link}
					</SG>
				</SG>
			</div>
		</div>
	);
};
